import { render, staticRenderFns } from "./ReportVDP.vue?vue&type=template&id=543db3d6&scoped=true"
import script from "./ReportVDP.vue?vue&type=script&lang=js"
export * from "./ReportVDP.vue?vue&type=script&lang=js"
import style0 from "./ReportVDP.vue?vue&type=style&index=0&id=543db3d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543db3d6",
  null
  
)

export default component.exports